<template lang="pug">
  transition(name="fade")
    .legend.legend_threads(:class="showMapLegend ? 'opened' : 'closed'")
      e-perfect-scrollbar
        .legend__head(@click="showMapLegend = !showMapLegend")
          h2.legend__title {{$translate('Обозначения')}}
          button.reset-btn.legend__close(v-if="showMapLegend")
          button.reset-btn.legend__open(v-else)
        .legend__group
          .legend__type
            label.legend__switch.switch
              span.semibold.legend__name Отобразить все элементы карты
              input.visually-hidden.switch__input(type="checkbox" @change="$emit('showAll', showAll)" v-model="showAll")
              span.switch__block
        .legend__group
          div.type.all-treads
            div.legend__type
              label.legend__switch.switch
                span.semibold.legend__name Отобразить все потоки
                input.visually-hidden.switch__input(type="checkbox" @change="$emit('showAllThreads', showAllThreads)" v-model="showAllThreads")
                span.switch__block
        map-operators(
          v-if="hasThreadsOperator"
          @setOperators="setOperators"
        )
        map-heat(@change="onChange" v-if='!isGuest')
        map-cadastre(v-if="hasMapCadastreBorders" @rosreestrChangeView="rosreestrChangeView")
        map-search-threads(v-if="hasSearchMapFields" :map="map" :year="year" @refreshMap="refreshMap")
        .legend__group
          .legend__type
            .semibold.legend__name {{$translate('Объекты обращения с отходами')}}
          .legend__small-group
            .legend__name
              .legend-icon.legend-icon_utilization
              span {{$translate('Объекты обращения с отходами')}}
          .legend__small-group
            .legend__name
              .legend-icon.legend-icon_mps
              span {{$translate('МПС (МПП)')}}
          .legend__small-group
            .legend__name
              .legend-icon.legend-icon_mmtzoo
              span {{$translate('ММЦОО')}}
        .legend__group
          .legend__type
            .semibold.legend__name {{$translate('Населенные пункты')}}
          .legend__small-group
            .legend__name
              .legend-icon.legend-icon_distribution
              span {{$translate('Отходы распределены')}}
        .legend__group
          .legend__type
            .custom-checkbox
              input.visually-hidden.custom-checkbox__input(type="checkbox" id="checkbox-thread" @change="showAllChange" v-model="showAllLine")
              label.legend__label.custom-checkbox__label(for="checkbox-thread")
                span.custom-checkbox__block
                span.custom-checkbox__text.semibold {{$translate('Потоки')}}
          .legend__small-group(v-for='(val,key) in threadConstants.pointTypes')
            .custom-checkbox
              input.visually-hidden.custom-checkbox__input(type="checkbox" :id="'chekbox-thread-' + key" @change="showHideLine(key)" v-model="showLines[key]")
              label.legend__label.custom-checkbox__label(:for="'chekbox-thread-' + key")
                span.custom-checkbox__block
                span(
                  :style="getLineStyle('fact', key)"
                ).legend__line
                span {{val}}
        .legend__group(v-if='hasThreadObjectLoad' )
          .legend__type
            .legend__name.semibold {{$translate('Нагрузка объекта')}}
          .legend__small-group
            .legend__name
              .legend__line.legend__line_low
              span {{$translate('Минимальная нагрузка')}}
          .legend__small-group
            .legend__name
              .legend__line.legend__line_middle
              span {{$translate('Средняя нагрузка')}}
          .legend__small-group
            .legend__name
              .legend__line.legend__line_high
              span {{$translate('Максимальная нагрузка')}}
        map-statuses(
          @updateStatus="updateStatus"
        )
        map-tko-dates(
          v-if="hasDateTkoFilter"
          :dateTkoStarts="dateTkoStarts"
          :dateTkoEnds="dateTkoEnds"
          @changeDateTko="changeDateTko"
        )
        map-fkko(
          v-if="hasFkkoFilter"
          @updateSearch='updateFkko'
        )
        map-danger-class(
          v-if="hasFkkoFilter"
          @updateDangerClass="updateDangerClass"
        )
        map-regop(
          v-if="hasRegopFilter"
          @updateRegop="updateRegop"
        )
</template>

<script>
import { threads } from '@/api/api-endpoints'
import year from '@/utils/year'
import hasMixin from '@/mixins/has-mixin'
import { TREADS_POLY_STYLE } from '@/config/map'
import MapFkko from './map-fkko'
import MapTkoDates from './map-tko-dates'
import MapDangerClass from './map-danger-class'
import MapRegop from './map-regop'
import MapStatuses from './map-statuses'
import MapOperators from './map-operators'
import MapHeat from './map-heat'
import MapCadastre from './map-cadastre'
import MapSearchThreads from './map-search-threads'

export default {
  name: 'map-legend',
  components: {
    MapRegop,
    MapFkko,
    MapDangerClass,
    MapTkoDates,
    MapStatuses,
    MapOperators,
    MapHeat,
    MapCadastre,
    MapSearchThreads,
  },
  mixins: [hasMixin],
  props: {
    showRemoved: {
      type: Boolean,
      default: false,
    },
    dateTkoStarts: {
      type: Array,
      default: function () {
        return []
      },
    },
    dateTkoEnds: {
      type: Array,
      default: function () {
        return []
      },
    },
    map: {
      type: Object,
    },
  },
  data: () => ({
    showAll: false,
    showAllThreads: false,
    showLines: { isEmpty: true },
    showAllLine: true,
    showAllStatus: true,
    showModelTariffs: false,
    threadConstants: { pointTypes: null, pointTypesColors: null },
    year: year.getCurrentYear(),
  }),
  computed: {
    showMapLegend: {
      get() {
        return this.$store.state.showMapLegend
      },
      set(value) {
        this.$store.commit('mapLegend', value)
      },
    },
    isGuest() {
      return this.$store.getters.isGuest
    },
  },
  methods: {
    async getThreadConstants() {
      let endpoint = threads.constants()

      const data = await this.$store.dispatch('updateUrlEndpoint', {
        endpoint,
      })

      let arr = data.data
      this.threadConstants = arr
      if (typeof arr.pointTypesColors == 'undefined') return {}
      if (this.showLines.isEmpty) {
        this.showLines = {}
        let keys = Object.keys(arr.pointTypesColors)
        for (let k in keys) {
          this.$set(this.showLines, keys[k], true)
        }
        this.$emit('initThreadTypes', keys)
      }
      return arr
    },
    showHideLine(key) {
      let vals = Object.values(this.showLines).filter((a) => a)
      let allKeys = Object.keys(this.threadConstants.pointTypesColors)
      this.showAllLine = vals.length === allKeys.length
      this.$emit('showHideLine', [key])
    },
    showAllChange() {
      let arr = Object.keys(this.threadConstants.pointTypesColors)
      this.$emit('showHideLine', null)
      if (this.showAllLine) {
        this.$emit('showHideLine', arr)
        for (let k in arr) {
          this.$set(this.showLines, arr[k], true)
        }
      } else {
        this.showLines = {}
      }
    },
    getLineStyle(type, subtype) {
      const style = { ...TREADS_POLY_STYLE[type] }
      // забиваем цвета из настроек
      if (
        this.threadConstants?.pointTypesColors &&
        subtype in this.threadConstants?.pointTypesColors
      ) {
        style.color = '#' + this.threadConstants.pointTypesColors[subtype]
      }

      if (style.dashArray) {
        return `background:repeating-linear-gradient(90deg, ${style.color}, ${style.color} 10px, transparent 10px, transparent 20px);`
      }

      return `background:${style.color};`
    },
    updateFkko(list) {
      this.$emit('updateFkko', list)
    },
    updateDangerClass(dangerClass) {
      this.$emit('updateDangerClass', dangerClass)
    },
    updateRegop(list) {
      this.$emit('updateRegop', list)
    },
    changeDateTko({ type, value }) {
      this.$emit('changeDateTko', { type, value })
    },
    updateStatus({ type, val }) {
      this.$emit('updateStatus', { type, val })
    },
    setOperators(data) {
      this.$emit('setOperators', data)
    },
    onChange(value) {
      this.$emit('change', value)
    },
    rosreestrChangeView(value) {
      this.$emit('rosreestrChangeView', value)
    },
    refreshMap() {
      this.$emit('refreshMap')
    },
  },
  created() {
    this.getThreadConstants()
    if (this.$isMobile()) {
      this.showMapLegend = false
    }
  },
}
</script>

<style lang="scss">
.legend.legend--treads .type-group .type.all {
  border-bottom: none;
  margin-left: -4px;
}

.legend.legend--treads .type-group .type.all-treads {
  border-top: none;
  margin-left: -4px;
}

/* снять ховер с элементов нагрузки */
.legend.legend--treads .type-group.loading .group .type:hover {
  background: inherit;
}

.main-layout .legend .type-group .type {
  padding-right: 15px;
}

.map-selects {
  width: 100%;

  .map-select + .map-select {
    margin-top: 20px;
  }

  span {
    display: inline-block;
    margin-left: 55px;
    margin-bottom: 10px;
    color: #29344c;
    font-weight: 500;
    line-height: 1.36;
    font-family: 'SFUIText-Semibold';
    font-size: 13px;
  }
}
</style>
